class GiftWrap extends HTMLElement {
  constructor() {
    super();

    // Reference to the elements
    this.checkbox = this.querySelector('input[type="checkbox"]#gift_wrap2') || this.querySelector('input[type="checkbox"]#gift_wrap');
    this.variantId = 50669582319947;
    this.checkbox.addEventListener('change', (e) => this.wrappingProduct(e));
  }

  removeWrappingProduct = () => {
    console.log('REMOVE')

    const giftWrapLine = document.querySelector(`[data-quantity-variant-id="50669582319947"]`);
    const cartDrawer = this;



        if (giftWrapLine) {
          fetch(`/cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: giftWrapLine.dataset.index,
              quantity: 0
            })
          })
            .then(response => response.json())
            .then(data => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                              source: 'product-form',
                              productVariantId: this.variantId,
                              cartData: data,
                            });


              console.log('Gift wrap removed successfully:', data);
            })
            .catch(error => {
              console.error('Error removing gift wrap:', error);
            });
        } else {
          console.error('Gift wrap line item not found.');
        }
  }
  addWrappingProduct = (body) => {
    console.log('ADD')

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
      .then(response => response.json())
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: this.variantId,
                        cartData: data,
                      });

        console.log('Gift wrap added successfully:', data);
        // cartDrawer.fetchUpdatedCartContents(giftWrapVariantId);
      })
      .catch(error => {
        console.error('Error adding gift wrap:', error);
      });

  }

  wrappingProduct = (e) => {
    console.log('click')
    console.log(e.target.checked)
    this.checkbox.checked = e.target.checked
    // Add loading state to the button
    this.classList.add('loading');
    console.log('click')

    if (e.target.checked) {
      // Prepare data to send
    console.log('checked')

      const data = {
        id: this.variantId,
        quantity: 1
      };
      this.addWrappingProduct(data)

    } else {
      console.log('notchecked')
      this.removeWrappingProduct()
    }

  }

}

// Register the custom element
customElements.define('gift-wrap', GiftWrap);
